import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  ButtonGroupTop,
  CustomTable,
  ModalError,
  Page,
  PrimaryButton,
  SearchTextInput,
  StatusChip,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { Fragment, useCallback, useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import ModalFormUnclaimOpenPeriod from "./ModalFormUnclaimOpenPeriod";

function UnclaimOpenPeriod() {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  
  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: 10,
    search: "",
  });
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [viewOnly, setViewOnly] = useState(false);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const handleOpenModal = (id = null, isView = false) => {
    setSelectedId(id);
    setViewOnly(isView);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedId(null);
    setViewOnly(false);
  };

  const getDataTable = async () => {
    const { page, per_page, search } = queryParams;
    const params = { page, size: per_page, search };
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/claim-configuration`,
        { headers, params }
      );

      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.per_page);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );

  useEffect(() => {
    debounceDataTable();
    return () => debounceDataTable.cancel();
  }, [queryParams, debounceDataTable]);

  return (
    <Fragment>
      <Page className={classes.root} title="Unclaim Open Period">
        <Container maxWidth={false}>
          <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
          <ButtonGroupTop />
          <Divider className={classes?.flatDivider} />
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            my="16px"
          >
            <Grid item>
              <SearchTextInput
                placeholder="Search"
                value={queryParams?.search}
                onChange={e =>
                  handleChangeQueryParams(e?.target?.value, "search")
                }
                disabled={loadingPage}
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                label="Add Period"
                startIcon={<Add />}
                onClick={() => handleOpenModal()}
                size="large"
                disabled={loadingPage}
              />
            </Grid>
          </Grid>
          <CustomTable
            isLoading={loadingPage}
            columnTable={columnTable}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.per_page}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "per_page")
            }
            isHaveAction
            handleEdit={item => handleOpenModal(item?.id)}
            handleView={item => handleOpenModal(item?.id, true)}
          />
        </Container>
      </Page>
      <ModalFormUnclaimOpenPeriod
        open={openModal}
        onClose={handleCloseModal}
        preload={selectedId}
        getDataTable={getDataTable}
        viewOnly={viewOnly}
      />
    </Fragment>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/unclaim-open-period",
  },
  {
    label: "Unclaim Open Period",
    active: true,
  },
];

const columnTable = [
  {
    name: "dsp_name",
    title: "DSP",
  },
  {
    name: "periods",
    title: "Data Period",
    renderText: item => {
      const list =
        item?.map(
          period =>
            `${moment(period?.start_date).format("DD MMMM YYYY")} - ${moment(
              period?.end_date
            ).format("DD MMMM YYYY")}`
        ) || [];
      return <ArrayChip list={list} max={2} />;
    },
  },
  {
    name: "publishers",
    title: "Publisher",
    renderText: item => {
      const list = item?.map(pub => pub?.publisher_name) || [];
      return <ArrayChip list={list} max={2} />;
    },
  },
  {
    name: "active_start",
    title: "Start Date",
    renderText: item => (item ? moment(item).format("DD MMMM YYYY") : "-"),
  },
  {
    name: "active_end",
    title: "End Date",
    renderText: item => (item ? moment(item).format("DD MMMM YYYY") : "-"),
  },
  {
    name: "is_active",
    title: "Status",
    renderText: item => (
      <StatusChip
        label={item ? "Active" : "Non Active"}
        type={item ? "active" : "default"}
      />
    ),
  },
];

export default UnclaimOpenPeriod;
